// @ts-nocheck
// Mirror the public form's Email-injection condition
// (apps/app/app/components/RegistrationContest/ContestPlayerDetails.tsx:152-160)
// so saved player fields include Email whenever the registration will actually
// collect it (per-player payment or a required waiver). Idempotent: leaves an
// existing email field untouched. Extracted from the retired wizard's
// LeagueSecondStep so the registration edit page and tests share one source.
import _ from 'lodash';

export default function ensureEmailField(fields, registration) {
  const paymentProduct = _.get(registration, 'paymentProduct', {});
  const isPlayerPaySeparately =
    !!paymentProduct?.playerPaySeparately && !!paymentProduct?.perPlayer;
  const playerWaivers = _.get(registration, 'playerWaivers', []);
  const hasRequiredWaiver = _.some(playerWaivers, (w) => w.required);
  if (!(isPlayerPaySeparately || hasRequiredWaiver)) return fields;
  if (_.find(fields, { fieldId: 'email' })) return fields;
  return [
    ...fields,
    {
      name: 'Email',
      fieldId: 'email',
      type: 'text',
      fieldType: 'textbox',
      primitiveType: 'string',
      required: true,
      helperText: 'Enter your email',
      permanent: true,
    },
  ];
}
